module.exports = __webpack_public_path__ + "img/pen-inactive.002f70f8.svg";